import React, { memo, useCallback } from 'react';
import useI18n from '../../../../i18n/hooks/useI18n';
import { ClaimOverviewWithReturnsDto, ReturnItemOverview } from '../../../../../typings/returns';

import S from './style/ReturnsDesktopTransactionInfo';

interface ReturnsDesktopTransactionProps {
  returnItem: ReturnItemOverview;
  isSeller: boolean;
}

interface ClaimsDesktopTransactionProps {
  claimItem: ClaimOverviewWithReturnsDto;
  isSeller: boolean;
}

const ReturnsDesktopTransaction: React.FC<ReturnsDesktopTransactionProps> = ({
  returnItem,
  isSeller,
}) => {
  const i18n = useI18n();
  const i18nKey = useCallback(key => i18n(`dlv_orders_details_${key}`), [i18n]);

  const userData = isSeller ? returnItem.buyerInfo : returnItem.sellerInfo;

  return (
    <S.TransactionInfo data-testid="returns-transaction-info" data-cy="returns-transaction-info">
      <S.InfoBlock>
        <S.InfoBlockTitle>{i18nKey`deliverymethod`}</S.InfoBlockTitle>
        <S.InfoBlockContent>{i18nKey`point_to_point`}</S.InfoBlockContent>
      </S.InfoBlock>
      <S.InfoBlock>
        <S.InfoBlockTitle>{i18nKey`paymentmethod`}</S.InfoBlockTitle>
        <S.InfoBlockContent>{i18nKey`online_payment`}</S.InfoBlockContent>
      </S.InfoBlock>
      <S.InfoBlock>
        <S.InfoBlockTitle data-testid="desktop-transaction-counterpart">
          {isSeller ? i18nKey`buyer` : i18nKey`seller`}
        </S.InfoBlockTitle>
        <S.InfoBlockContent>{userData.name}</S.InfoBlockContent>
        <S.InfoBlockContent bold>{userData.phone}</S.InfoBlockContent>
      </S.InfoBlock>
    </S.TransactionInfo>
  );
};

const ClaimsDesktopTransaction: React.FC<ClaimsDesktopTransactionProps> = ({
  claimItem,
  isSeller,
}) => {
  const i18n = useI18n();
  const i18nKey = useCallback(key => i18n(`dlv_orders_details_${key}`), [i18n]);

  const userData = isSeller ? claimItem.adDetails.buyer : claimItem.adDetails.seller;

  return (
    <S.TransactionInfo data-testid="returns-transaction-info" data-cy="returns-transaction-info">
      <S.InfoBlock>
        <S.InfoBlockTitle>{i18nKey`deliverymethod`}</S.InfoBlockTitle>
        <S.InfoBlockContent>{i18nKey`point_to_point`}</S.InfoBlockContent>
      </S.InfoBlock>
      <S.InfoBlock>
        <S.InfoBlockTitle>{i18nKey`paymentmethod`}</S.InfoBlockTitle>
        <S.InfoBlockContent>{i18nKey`online_payment`}</S.InfoBlockContent>
      </S.InfoBlock>
      <S.InfoBlock>
        <S.InfoBlockTitle data-testid="desktop-transaction-counterpart">
          {isSeller ? i18nKey`buyer` : i18nKey`seller`}
        </S.InfoBlockTitle>
        <S.InfoBlockContent>{userData.name}</S.InfoBlockContent>
        <S.InfoBlockContent bold>{userData.phone}</S.InfoBlockContent>
      </S.InfoBlock>
    </S.TransactionInfo>
  );
};

const ReturnsDesktopTransactionInfo = memo(ReturnsDesktopTransaction);
const ClaimsDesktopTransactionInfo = memo(ClaimsDesktopTransaction);

export { ReturnsDesktopTransactionInfo, ClaimsDesktopTransactionInfo };
